export default __webpack_public_path__ + "static/media/house-1.25d7d138.jpg";